/* eslint react/no-array-index-key: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import cx from 'classnames';

import CalendarMonthOption from './CalendarMonthOption';

import { calendarYearQuarters, isSameMonth } from './month';

import OrientationShape from 'react-dates/lib/shapes/OrientationShape';

import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from 'react-dates/constants';

import './CalendarYear.scss';

const propTypes = {
  year: PropTypes.func,
  isVisible: PropTypes.bool,
  modifiers: PropTypes.object,
  orientation: OrientationShape,
  onMonthClick: PropTypes.func,
  onMonthMouseDown: PropTypes.func,
  onMonthMouseUp: PropTypes.func,
  onMonthMouseEnter: PropTypes.func,
  onMonthMouseLeave: PropTypes.func,
  onMonthTouchStart: PropTypes.func,
  onMonthTouchEnd: PropTypes.func,
  onMonthTouchTap: PropTypes.func,

  focusedDate: momentPropTypes.momentObj, // indicates focusable month
  isFocused: PropTypes.bool, // indicates whether or not to move focus to focusable month

  yearFormat: PropTypes.string,
};

const defaultProps = {
  year: () => moment(),
  isVisible: true,
  modifiers: {},
  orientation: HORIZONTAL_ORIENTATION,
  onMonthClick() {},
  onMonthMouseDown() {},
  onMonthMouseUp() {},
  onMonthMouseEnter() {},
  onMonthMouseLeave() {},
  onMonthTouchStart() {},
  onMonthTouchEnd() {},
  onMonthTouchTap() {},

  focusedDate: null,
  isFocused: false,

  yearFormat: 'YYYY',
};

export function getModifiersForMonth(modifiers, month) {
  return month ? Object.keys(modifiers).filter(key => modifiers[key](month)) : [];
}

const quarter = (year, nthQuarter) => `${year.format('YYYY')}-${nthQuarter}`;

export default function CalendarYear(props) {
  const {
    year,
    yearFormat,
    orientation,
    isVisible,
    modifiers,
    onMonthClick,
    onMonthMouseDown,
    onMonthMouseUp,
    onMonthMouseEnter,
    onMonthMouseLeave,
    onMonthTouchStart,
    onMonthTouchEnd,
    onMonthTouchTap,

    focusedDate
  } = props;

  const activeYear = year();
  const yearTitle = activeYear.format(yearFormat);
  const calendarYearClasses = cx('CalendarYear', {
    'CalendarYear--horizontal': orientation === HORIZONTAL_ORIENTATION,
    'CalendarYear--vertical': orientation === VERTICAL_ORIENTATION,
  });

  return (
    <div className={calendarYearClasses} data-visible={isVisible}>
      <table>
        <caption className="CalendarYear__caption js-CalendarYear__caption">
          <strong>{yearTitle}</strong>
        </caption>

        <tbody className="js-CalendarYear__grid">
          {calendarYearQuarters(activeYear).map((quarterMonths, i) =>
            <tr key={quarter(activeYear, i)}>
              {quarterMonths.map((month) => {
                const modifiersForMonth = getModifiersForMonth(modifiers, month);
                const isMonthFocused = isVisible && isSameMonth(month, focusedDate);

                const className = cx('CalendarYear__month',
                  modifiersForMonth.map(mod => `CalendarYear__month--${mod}`));

                return (
                  <td className={className} key={month.format('YYYY-MM')}>
                    <CalendarMonthOption
                      tabIndex={isMonthFocused ? 0 : -1}
                      isFocused={isMonthFocused}

                      month={() => month}
                      modifiers={modifiersForMonth}
                      onMonthMouseEnter={onMonthMouseEnter}
                      onMonthMouseLeave={onMonthMouseLeave}
                      onMonthMouseDown={onMonthMouseDown}
                      onMonthMouseUp={onMonthMouseUp}
                      onMonthClick={onMonthClick}
                      onMonthTouchStart={onMonthTouchStart}
                      onMonthTouchEnd={onMonthTouchEnd}
                      onMonthTouchTap={onMonthTouchTap}
                    />
                  </td>
                );
              })}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

CalendarYear.propTypes = propTypes;
CalendarYear.defaultProps = defaultProps;
